import { auth, functionsBaseUrl } from "../../firebase";

export const getOrdersCsvDownloadUrl = async (restaurantId: string):  Promise<{ success: boolean, downloadUrl?: string, error: string }> => {
  try {
    if (!auth.currentUser) {
      return { success: false,  error: "Customer Not Signed In" };
    }
    const idToken: string = await auth.currentUser.getIdToken()
    const body = { restaurantId }

    const response = await fetch(`${functionsBaseUrl}/exportRestaurantOrders`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${idToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
    console.log(response)
    return (await response.json() as { success: boolean, downloadUrl: string, error: string });
  } catch (error) {
    return {success: false, error: "Something went wrong"}
  }
};